:host {
  @include reset-host;

  height: 100%;
}

:host .video-modal-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 100%;

  color: $white;
  font-size: rem(20);

  background: $black;

  .index-text {
    font-weight: $fw-bold;
    font-size: rem(50);
  }

  /* stylelint-disable-next-line selector-max-compound-selectors */
  .video-player iframe {
    @include cover;
    object-fit: unset; // for Safari to display the video

    pointer-events: none;

    @include mq('max', 'sm') {
      position: absolute;
      top: 50%;
      left: 50%;

      width: 100vw;
      height: 100vh;

      transform: translate(-50%, -50%);

      @media (min-aspect-ratio: 9/16) {
        /* height = 100 * (9 / 16) = 56.25 */
        height: 177.78vw;
      }
      @media (max-aspect-ratio: 9/16) {
        /* width = 100 / (9 / 16) = 177.777777 */
        width: 56.25vh;
      }
    }
  }
}
